import * as React from 'react';
import {Button, KIND} from 'baseui/button';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalButton,
} from 'baseui/modal';
import {useEffect} from "react";
import {Badge, COLOR} from "baseui/badge";
import {useStyletron} from "baseui";
import {RightAlign} from "./layout";
import badRobot from "/z30-images/robot-alert.png"
import {translate, useLazyCommand} from "@soap/modules";

export default function ErrorModal({children, closeButtonText = "Dismiss", onButtonCloseAsync, onClose=() => {}, secondaryButton}) {

    const [isOpen, setIsOpen] = React.useState(true);
    const [css] = useStyletron();

    useEffect(() => {
        if (children) {
            setIsOpen(true);
        }
    }, [children])

    // Add global style for error modal z-index to ensure it appears above all dialogs
    React.useEffect(() => {
        const styleId = 'error-modal-z-index-fix';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = `
                /* Target error modal specifically using className */
                .error-modal-high-z {
                    z-index: 10000 !important;
                }
                .error-modal-high-z > div {
                    z-index: 10000 !important;
                }
                .error-modal-high-z [role="dialog"] {
                    z-index: 10001 !important;
                    position: relative;
                }
            `;
            document.head.appendChild(style);
        }
        return () => {
            // Don't remove the style as it should persist for all error modals
        };
    }, []);

    function closeWithButton() {
        (async function() {
            if (onButtonCloseAsync) {
                const result = await onButtonCloseAsync();
                if (result === false) return;
            }
            onClose();
            setIsOpen(false);
        })();
    }
    
    function closeWithX() {
        onClose();
        setIsOpen(false);
    }
  
    return (
        <React.Fragment>
            <Modal 
                onClose={closeWithX} 
                isOpen={isOpen} 
                autoFocus={false}
                overrides={{
                    Root: {
                        props: {
                            className: 'error-modal-high-z'
                        },
                        style: ({$theme}) => ({
                            zIndex: 10000
                        })
                    },
                    Backdrop: {
                        style: ({$theme}) => ({
                            zIndex: 10000
                        })
                    },
                    DialogContainer: {
                        style: ({$theme}) => ({
                            zIndex: 10001
                        })
                    },
                    Dialog: {
                        style: ({$theme}) => ({
                            zIndex: 10001
                        })
                    }
                }}
            >
                <ModalHeader>{translate(`$ErrorModalHeader`)}<RightAlign><img src={badRobot}
                                                                   height={70} width={70} alt="" style={{objectFit: "contain"}}/></RightAlign></ModalHeader>
                <ModalBody>
                    {children}
                </ModalBody>
                <ModalFooter>
                    {secondaryButton ? (
                        <>
                            <ModalButton kind={KIND.tertiary} onClick={secondaryButton.onClick}>{secondaryButton.label}</ModalButton>
                            <ModalButton onClick={closeWithButton}>{translate(closeButtonText)}</ModalButton>
                        </>
                    ) : (
                        <ModalButton onClick={closeWithButton}>{translate(closeButtonText)}</ModalButton>
                    )}
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}